export default __webpack_public_path__ + "static/media/filter.efa41825.svg";